import(/* webpackMode: "eager", webpackExports: ["AuthForm"] */ "/vercel/path0/app/(auth)/auth/_components/auth-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/components/footer.tsx");
